import { TableCell, TableRow } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../context/AuthContext";

const InvoicePayment = ({ id, invoice, paymentMethods, depositAccounts }) => {
  const { authToken, ezorder } = useContext(AuthContext);
  const [payment, setPayment] = useState(null);
  const [loading, setLoading] = useState(false);

  // TODO: Load Linked Transaction

  const getPaymentDetails = async (controller) => {
    try {
      setLoading(true);
      let data = {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      };
      if (controller) {
        data.signal = controller.signal;
      }

      const response = await ezorder.get(`/quickbooks/payment/${id}`, data);

      console.log(response.data.payment[0]);
      setPayment(response.data.payment[0]);
      //   setInvoice(response.data.invoice);
      //   setInvoiceLink(response.data.invoice.InvoiceLink);
      //   setPaymentLines([response.data.invoice]);
    } catch (error) {
      console.log("Failed To Load Payment", id);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPaymentDetails();
  }, []);
  if (payment && invoice) {
    let amountApplied = 0;
    for (let line of payment.Line) {
      if (line.LinkedTxn) {
        for (let linkedTxn of line.LinkedTxn) {
          if (linkedTxn.TxnId == invoice.Id) amountApplied = line.Amount;
        }
      }
    }

    if (payment && paymentMethods) {
      let paymentMethodRef = payment.PaymentMethodRef;

      let paymentMethod = null;
      if (paymentMethodRef != null && paymentMethodRef != undefined) {
        paymentMethod = paymentMethods.find(
          (pm) => pm.Id == payment.PaymentMethodRef.value
        );
      }
      let paymentMethodString = "";
      if (paymentMethod) {
        paymentMethodString = paymentMethod.Name;
      }

      return (
        <TableRow>
          <TableCell>{payment.TxnDate}</TableCell>
          <TableCell>{paymentMethodString}</TableCell>
          <TableCell>{payment.PaymentRefNum}</TableCell>
          <TableCell>
            {
              depositAccounts.find(
                (da) => da.Id == payment.DepositToAccountRef.value
              )?.Name
            }
          </TableCell>
          <TableCell>${payment.TotalAmt}</TableCell>
          <TableCell>${amountApplied}</TableCell>
        </TableRow>
      );
    }
  }
};

export default InvoicePayment;
